import '../App.css'

export default function Contact() {

    return (
        <div>
            <main role="main" className="flex-shrink-0 min-vh-100">
                <div className='container mt-4'>
                    <div className='row'>
                        <div className='col-lg-6'>

                            <h3>
                                Contacts
                            </h3>
                            <p>
                                For further information, please contact:
                            </p>

                            <h5>Cole Walker</h5>
                            <p>
                                Region F Water Planning Group Chair <br />
                                <a href="mailto:cwalker@crmwd.org">cwalker@crmwd.org </a><br />
                                432-267-6341 <br />
                            </p>

                            <h5>Heather Rose</h5>
                            <p>
                                Texas Water Development Board<br />
                                <a href="mailto:heather.rose@twdb.texas.gov">heather.rose@twdb.texas.gov</a><br />
                                512-475-1558<br />
                            </p>

                            <h5>Lissa Gregg, P.E.</h5>
                            <p>
                                Freese and Nichols, Inc.<br />
                                <a href="mailto:lissa.gregg@freese.com">lissa.gregg@freese.com</a><br />
                                817-735-7328<br />
                            </p>
                        </div>
                        <div className='col-lg-6 mt-4'>

                            <h5>Political Subdivision</h5>
                            <p>
                                Colorado River Municipal Water District<br />
                                400 E. 24th Street<br />
                                Big Spring, Texas 79720<br />
                                (432) 267-6341<br />
                            </p>

                            <h5>Lead Consultant</h5>
                            <p>
                                Freese and Nichols Inc.<br />
                                801 Cherry St # 2800<br />
                                Fort Worth, TX 76102<br />
                                817-735-7300<br />
                            </p>

                            <h5>Texas Water Development Board</h5>
                            <p>
                                Stephen F. Austin Bldg.<br />
                                P.O. Box 13231<br />
                                Austin, Texas 78711-3231<br />
                                512-463-7847<br />
                            </p>

                        </div>
                        
                    </div>
                </div>
            </main >
        </div >
    )
}